import {
  GET_USER_FAIL,
  GET_USER_SUCCESS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  GET_OPERATIVES_SUCCESS,
  GET_TECHADVISORS_SUCCESS,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,  
  SET_STATE_USER,
  UPDATE_USER_CHECK,
  UPDATE_OPERATIVE_CHECK,
  UPDATE_TECHADVISOR_CHECK
} from "./actionTypes";

const INIT_STATE = {
  users: [],
  user: {},
  techAdvisors: [],
  operatives: [],
  totalOperatives: 0,
  currentPageOperatives: 0,
  totalTechAdvisors: 0,
  currentPageTechAdvisors: 0,
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const users = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS_SUCCESS:
      return {
        ...state,
        // users: action.payload.users,
        users: action.payload.users.map(user => {
          return {...user, checked: false}
        }),
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };
    
    case GET_OPERATIVES_SUCCESS:
    return {
      ...state,
      // users: action.payload.users,
      operatives: action.payload.operatives.map(operative => {
        return {...operative, checked: operative.checked}
      }),
      totalOperatives: action.payload.totalOperatives,
      currentPageOperatives: action.payload.currentPageOperatives,
    };

    case GET_TECHADVISORS_SUCCESS:
    return {
      ...state,
      // users: action.payload.users,
      techAdvisors: action.payload.techAdvisors.map(user => {
        return {...user, checked: user.checked}
      }),
      totalTechAdvisors: action.payload.totalTechAdvisors,
      currentPageTechAdvisors: action.payload.currentPageTechAdvisors,
    };
      

    case SET_STATE_USER:
      return { ...state, loading: action.payload }

    case GET_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_USER_SUCCESS:
      return {
        ...state,
        users: [...state.users, action.payload],
      };

    case ADD_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    
    case UPDATE_USER_CHECK:
    return {
      ...state,
      users: state.users.map(user =>
        user.id.toString() === action.payload.id.toString()
          ? { ...user, checked: action.payload.checked }
          : user
      ),
    };

    case UPDATE_OPERATIVE_CHECK:
    return {
      ...state,
      operatives: state.operatives.map(operative =>
        operative.id.toString() === action.payload.id.toString()
          ? { ...operative, checked: action.payload.checked }
          : operative
      ),
    };

    case UPDATE_TECHADVISOR_CHECK:
    return {
      ...state,
      techAdvisors: state.techAdvisors.map(techAdvisor =>
        techAdvisor.id.toString() === action.payload.id.toString()
          ? { ...techAdvisor, checked: action.payload.checked }
          : techAdvisor
      ),
    };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map(user =>
          user.id.toString() === action.payload.id.toString()
            ? { ...user, ...action.payload }
            : user
        ),
        operatives: state.operatives.map(operative =>
          operative.id.toString() === action.payload.id.toString()
            ? { ...operative, ...action.payload }
            : operative
        ),
        techAdvisors: state.techAdvisors.map(techAdvisor =>
          techAdvisor.id.toString() === action.payload.id.toString()
            ? { ...techAdvisor, ...action.payload }
            : techAdvisor
        ),
      };

    case UPDATE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.filter(
          user => user.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
      };

    case GET_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default users;
